/* eslint-disable react-hooks/exhaustive-deps */
import { Spin, Tag, Timeline } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import IconEmpty from '../../../../../../assets/Images/icons/empty';
import { ROUTER } from '../../../../../../constants/router';
import { useEffect, useState } from 'react';
import TemplateDesignService from '../../../../../../services/TemplateDesign.service';

export default function HistoryDrawer({
    templateKey,
    isChangeStatus,
    setIsChangeStatus,
}) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const _getTagStatus = (e) => {
        switch (e?.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {/* {i18n.language === 'en'? e.statusEn : e.statusTh} */}
                        {e?.status} {e?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {/* {i18n.language === 'en' ? e.statusEn : e.statusTh} */}
                        {e?.status} {e?.latestPublishVersion}
                    </Tag>
                );
            default:
                return '-';
        }
    };
    // History
    const [histories, setHistories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const getHistory = async (params) => {
        setLoading(true);
        try {
            setTimeout(async () => {
                const { data } = await TemplateDesignService.getHistories(
                    params
                );
                if (data?.resultData) {
                    if (params.p === 1) {
                        setHistories(data.resultData?.result);
                        setPage(2);
                    } else {
                        const history = histories.concat(
                            data.resultData?.result
                        );
                        setHistories(history);
                        setPage(page + 1);
                    }
                    setTotal(data?.resultData?.total);
                    setLoading(false);
                }
            }, 300);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        if (isChangeStatus && templateKey) {
            const params = {
                templateDesignKey: templateKey,
                p: 1,
                ps: 10,
                sd: 'DESC',
            };
            setHistories([]);
            getHistory(params);
            setIsChangeStatus(false);
        }
    }, [isChangeStatus, templateKey]);

    const scrollEvent = (e) => {
        const scrollTop = e.target.scrollTop;
        const scrollHeight = e.target.scrollHeight - e.target.clientHeight;
        const threshold = scrollHeight * 0.9; // 90% of the total height
        if (scrollTop >= threshold && total > histories.length && !loading) {
            const params = {
                templateDesignKey: templateKey,
                p: page,
                ps: 10,
                sd: 'DESC',
            };
            getHistory(params);
        }
    };

    return (
        <Timeline>
            <Spin spinning={loading}>
                <div
                    onScroll={scrollEvent}
                    className="h-[95vh] overflow-y-scroll p-4 pb-12"
                >
                    {histories.length > 0 ? (
                        histories.map((item, i) => (
                            <Timeline.Item
                                key={item?.historyId}
                                color={i === 0 ? '#F0536F' : '#3699FF'}
                            >
                                <button
                                    className={classNames(
                                        'bg-[#EDEEF9] p-2 rounded-lg space-y-2 cursor-pointer hover:opacity-90 text-left w-full',
                                        { 'bg-[#F4F6FC]': i !== 0 }
                                    )}
                                    onClick={() => {
                                        navigate(
                                            `${ROUTER.CONSENT_MANAGEMENT.TEMPLATE_DESIGN}/${item?.historyId}/history`
                                        );
                                    }}
                                >
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('LogDate')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.logDate
                                                ? moment(item?.logDate).format(
                                                      'DD/MM/YYYY HH:mm'
                                                  )
                                                : '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('Update By')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.updateBy || '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('Version')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.version || '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('Action')} :
                                        </div>
                                        <div className="col-span-2">
                                            <span>
                                                <Tag
                                                    className="rounded-xl -my-1 text-center px-4 text-white"
                                                    color="#7B67FB"
                                                >
                                                    {i18n.language === 'en'
                                                        ? item?.action
                                                        : item?.action}
                                                </Tag>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-3 text-xs">
                                        <div className="col-span-1 font-semibold">
                                            {t('Status')} :
                                        </div>
                                        <div className="col-span-2">
                                            <span>{_getTagStatus(item)}</span>
                                        </div>
                                    </div>
                                </button>
                            </Timeline.Item>
                        ))
                    ) : (
                        <div className="h-[30vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </Spin>
        </Timeline>
    );
}
